import React from "react";
import { CheckIcon } from "lucide-react";
import { learnings } from "../data/book";
export function AboutBook() {
  return <section id="book" className="scroll-mt-20 border-t border-line bg-night py-24 lg:py-32" data-id="element-12" data-mp="356sjl1qqt1dr">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-[1fr_1.1fr] lg:gap-20 lg:px-10" data-id="element-13" data-mp="30dr3iqesuvsl">
        <div data-id="element-14" data-mp="2vewkbncx757y">
          <h2 className="font-display text-4xl leading-tight text-cream sm:text-5xl" data-id="element-15" data-mp="2vf6abaxytcdn">
            Increase your odds
            <br data-id="element-16" data-mp="2qeibi33hvr8v" />
            <span className="text-gold" data-id="element-17" data-mp="2lhi67uegysit">before you start.</span>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-18" data-mp="2ljmjv42675wa">
            Reading more books, working 12-hour days, or knowing the right people don’t change the
            odds. The right mentorship does, but most founders never get it for the stage
            they’re actually in.
          </p>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-19" data-mp="fmh2bb1xqxd4">
            <em className="font-serif text-cream" data-id="element-20" data-mp="aqs00zyj72d4">The Mentored Founder</em> is that mentorship in
            written form: the operating patterns of people who built enduring companies, organized
            around the failure modes that stop most new businesses before they start.
          </p>

          <div className="mt-10 flex items-end gap-5 border-t border-line pt-8" data-id="element-21" data-mp="39hsd111q03lj">
            <span className="font-display text-7xl leading-none text-gold sm:text-8xl" data-id="element-22" data-mp="3ees9qlcojtzz">3×</span>
            <p className="max-w-[16rem] pb-1 font-serif text-xl leading-snug text-cream" data-id="element-23" data-mp="5zi97hofuwub">
              Mentored founders are roughly three times more likely to stay in business.
            </p>
          </div>
        </div>

        <div className="lg:pt-2" data-id="element-24" data-mp="3sejtl2pvo4lw">
          <h3 className="font-serif text-sm tracking-[0.3em] text-gold" data-id="element-25" data-mp="3sdig6rle3610">YOU’LL LEARN</h3>
          <ul className="mt-6 divide-y divide-line border-y border-line" data-id="element-26" data-mp="16xjar8nl3w2">
            {learnings.map(item => <li key={item} className="flex gap-4 py-5" data-id="element-27" data-mp="owjg581jz70w">
                <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-28" data-mp="tqe97231sycn">
                  <CheckIcon className="h-3 w-3 text-ink" strokeWidth={3} data-id="element-29" data-mp="13k0d6q8yps07" />
                </span>
                <span className="text-lg leading-relaxed text-cream/90" data-id="element-30" data-mp="ynjmboadozjf">{item}</span>
              </li>)}
          </ul>
          <p className="mt-8 font-serif text-xl italic leading-snug text-muted" data-id="element-31" data-mp="tlas6olrrrfq">
            Founding a company is the fastest way to build a fortune, and also the most reliable
            way to go broke. This book is written to shift the odds toward the first.
          </p>
        </div>
      </div>
    </section>;
}